import { render, staticRenderFns } from "./HaiBoTangOrderRefunds.vue?vue&type=template&id=79b37ed7&scoped=true"
import script from "./HaiBoTangOrderRefunds.vue?vue&type=script&lang=js"
export * from "./HaiBoTangOrderRefunds.vue?vue&type=script&lang=js"
import style0 from "./HaiBoTangOrderRefunds.vue?vue&type=style&index=0&id=79b37ed7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b37ed7",
  null
  
)

export default component.exports